import * as React from "react";
import styled from "@mui/material/styles/styled";
import { useClinicContext } from "fe-web-components/clinic/ClinicContext";
import { ClinicSelectionDialog } from "../clinicSelectionDialog";
import { useClinicUserContext } from "../clinicUserContext";
//region [[ Styles ]]
const PatientTableCopyCaseView = styled("div")(({ theme }) => ({}));
//endregion [[ Styles ]]
//region [[ Props ]]
export interface PatientTableCopyCaseProps {
  caseId: string;
  srcClinicId: string;
  onSave: () => void;
  onClose: () => void;
}
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]
export const PatientTableCopyCase = ({
  ...props
}: PatientTableCopyCaseProps) => {
  const clinicDao = useClinicContext();

  const onCopy = (destClinicId) => {
    clinicDao
      .copyCaseToClinic(props.srcClinicId, destClinicId, props.caseId)
      .then(props.onSave)
      .then(props.onClose);
  };

  const { userClinics } = useClinicUserContext();

  return (
    <PatientTableCopyCaseView>
      <ClinicSelectionDialog
        open={true}
        onClose={props.onClose}
        userClinics={userClinics}
        goToClinic={(destClinicId) => onCopy(destClinicId)}
        currentClinicId={null}
        onToggleUserClinic={null}
      />
    </PatientTableCopyCaseView>
  );
};
